import { addMonths } from 'date-fns';
import { useCurrentModule } from './useCurrentModule';
import { useModulePlanningRange } from './useModulePlanningRange';

export const useMonthKeys = () => {
    const module = useCurrentModule();
    const planningRange = useModulePlanningRange(module);

    const monthKeysLength = planningRange === 'EIGHTEEN_MONTHS' ? 18 : 12;
    const monthKeys = Array.from({ length: monthKeysLength }).map((_, index) => {
        const date = new Date();
        const newDate = addMonths(date, index);

        return Number(`${newDate.getFullYear()}${(newDate.getMonth() + 1).toString().padStart(2, '0')}`);
    });

    return monthKeys;
};
